import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "orderBy",
  standalone: false,
})
export class OrderByPipe implements PipeTransform {
  transform(array: any, field: string) {
    return array.sort((a, b) => {
      if (!field) {
        return 0;
      }
      if (a[field] < b[field]) {
        return -1;
      }
      if (a[field] > b[field]) {
        return 1;
      }
      return 0;
    });
  }
}
